module.exports = {
    INCLUSIVE : "inclusive"
};